import React, {Component} from "react";
import "./TourStepContent.css";
import TourGuyImage from "../../assets/images/tour_guy_image.png";

class TourStepContent extends Component {
    render(){
        const {
            title = "Assets",
            subtitle = "It is a long established fact that a reader will readable content of a page when looking at its layout"
        } = this.props;
        return (
            <React.Fragment>
                <div
                    className="tour-step-content-cnt"
                >
                    <div>
                        <h1 className="tour-step-content-h1">{title}</h1>
                        <p className="tour-step-content-p">{subtitle}</p>
                    </div>
                    <img className="tour-step-content-img" src={TourGuyImage} alt="guy" />
                </div>
            </React.Fragment>
        );
    }
}

export default TourStepContent;
